/* Team K9 brand bands (home page). One run for every band on the page; the page reads fine without it. */
(function () {
  "use strict";
  if (window.__tkbInit) return;
  window.__tkbInit = true;
  var roots = Array.prototype.slice.call(document.querySelectorAll("[data-tkb]"));
  if (!roots.length) return;
  function $$(sel) { return Array.prototype.slice.call(document.querySelectorAll(".tkb " + sel)); }
  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var saveData = navigator.connection && (navigator.connection.saveData || /2g|3g/.test(navigator.connection.effectiveType || ""));
  var fmt = new Intl.NumberFormat("en-US");

  /* reveal on scroll */
  var targets = $$("[data-tkb-rv]");
  if ("IntersectionObserver" in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px 12% 0px", threshold: 0.01 });
    targets.forEach(function (n) { io.observe(n); });
  } else {
    targets.forEach(function (n) { n.classList.add("is-in"); });
  }

  /* live numbers: buyers from the sitewide proof-stats tag, review total from the Loox storefront API */
  var proofTag = document.querySelector("script[data-customer-count]");
  var buyers = proofTag ? parseInt(String(proofTag.getAttribute("data-customer-count")).replace(/[^\d]/g, ""), 10) : 0;
  if (buyers > 1000) {
    $$("[data-tkb-buyers-round]").forEach(function (n) { n.textContent = fmt.format(Math.floor(buyers / 1000) * 1000); });
    $$("[data-tkb-buyers]").forEach(function (n) { n.textContent = fmt.format(buyers); });
  }
  var storeId = roots[0].getAttribute("data-loox-store");
  if (storeId && window.fetch && document.querySelector(".tkb [data-tkb-reviews]")) {
    fetch("https://storefront-api.loox.io/storefront/v1/store/" + storeId + "/product-reviews?limit=1&page=1", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { var total = j && j.pagination && Number(j.pagination.total); if (total > 1000) $$("[data-tkb-reviews]").forEach(function (n) { n.textContent = fmt.format(total); }); })
      .catch(function () {});
  }

  /* marquee: duplicate the row so the -50% loop is seamless */
  if (!reduceMotion) $$("[data-tkb-marquee]").forEach(function (track) {
    Array.prototype.slice.call(track.children).forEach(function (child) { var c = child.cloneNode(true); c.setAttribute("aria-hidden", "true"); track.appendChild(c); });
  });

  /* the film: loads when near, plays muted while in view, sound is opt-in */
  var film = document.querySelector(".tkb [data-tkb-film]");
  if (film) {
    var frame = film.closest("[data-tkb-film-frame]");
    var toggle = frame.querySelector("[data-tkb-film-toggle]");
    var sound = frame.querySelector("[data-tkb-film-sound]");
    var soundLabel = frame.querySelector("[data-tkb-film-sound-label]");
    var userPaused = false;
    var load = function () {
      if (film.getAttribute("src")) return;
      var small = film.getAttribute("data-src-sm");
      var phone = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
      film.setAttribute("src", small && phone ? small : film.getAttribute("data-src"));
    };
    var play = function () { load(); var p = film.play(); if (p && p.catch) p.catch(function () {}); };
    film.addEventListener("play", function () { frame.classList.add("is-playing"); toggle.setAttribute("aria-label", "Pause the film"); });
    film.addEventListener("pause", function () { frame.classList.remove("is-playing"); toggle.setAttribute("aria-label", "Play the film"); });
    toggle.addEventListener("click", function () { if (film.paused) { userPaused = false; play(); } else { userPaused = true; film.pause(); } });
    sound.addEventListener("click", function () {
      var on = film.muted;
      film.muted = !on;
      sound.setAttribute("aria-pressed", on ? "true" : "false");
      soundLabel.textContent = on ? "Sound on" : "Tap for sound";
      if (on) { userPaused = false; if (film.paused) play(); }
    });
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (e.isIntersecting && e.intersectionRatio > 0.5) { if (!userPaused && !reduceMotion && !saveData) play(); }
        else if (!film.paused) film.pause();
      }, { threshold: [0, 0.5, 1] }).observe(film);
    }
  }

  /* tap-to-play films (the story film): sound on, native controls, one film at a time */
  $$("[data-tkb-vid]").forEach(function (box) {
    var video = box.querySelector("video"), button = box.querySelector("[data-tkb-vid-play]");
    if (!video || !button) return;
    button.addEventListener("click", function () {
      if (!video.getAttribute("src")) {
        var small = video.getAttribute("data-src-sm");
        var phone = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;
        video.setAttribute("src", small && phone ? small : video.getAttribute("data-src"));
      }
      video.controls = true;
      box.classList.add("is-playing");
      if (film && !film.paused) film.pause();
      var p = video.play(); if (p && p.catch) p.catch(function () {});
    });
  });

  /* customer clips on the route cards: posters when the row is near, play muted only while in view */
  var clips = $$("[data-tkb-clip]");
  if (clips.length) {
    var setPoster = function (v) { if (!v.getAttribute("poster") && v.getAttribute("data-poster")) v.setAttribute("poster", v.getAttribute("data-poster")); };
    if ("IntersectionObserver" in window) {
      var rail = clips[0].closest(".tkb-routes") || clips[0];
      var posterIO = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { clips.forEach(setPoster); posterIO.disconnect(); } }, { rootMargin: "900px 0px" });
      posterIO.observe(rail);
      if (!reduceMotion && !saveData) {
        var clipIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
              if (!v.getAttribute("src")) v.setAttribute("src", v.getAttribute("data-src"));
              var p = v.play(); if (p && p.catch) p.catch(function () {});
            } else if (!v.paused) v.pause();
          });
        }, { threshold: [0, 0.6, 1] });
        clips.forEach(function (v) { clipIO.observe(v); });
      }
    } else {
      clips.forEach(setPoster);
    }
  }

  /* phone shop bar: after the hero, hidden again at the closer */
  var sticky = document.querySelector(".tkb [data-tkb-sticky]");
  var hero = document.querySelector(".tkb .tkb-hero");
  var closer = document.querySelector(".tkb .tkb-closer");
  if (sticky && hero && "IntersectionObserver" in window) {
    sticky.hidden = false;
    var heroOut = false, closerIn = false;
    var sync = function () { sticky.classList.toggle("is-on", heroOut && !closerIn); };
    new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; sync(); }, { threshold: 0 }).observe(hero);
    if (closer) new IntersectionObserver(function (e) { closerIn = e[0].isIntersecting || e[0].boundingClientRect.top < 0; sync(); }, { threshold: [0, 0.2] }).observe(closer);
  }

  /* smooth scroll for the in-page jump */
  $$('a[href^="#tkb-"]').forEach(function (a) {
    a.addEventListener("click", function (event) {
      var target = document.getElementById(a.getAttribute("href").slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    });
  });
})();

/* copy deterrent (owner, 2026-10-04: "dont let folks copy/click on the pages so it's harder to control c"). Inside the brand
   sections: no text selection, no dragging or right-click menu on pictures and plain text, no copy. Form fields, help answers
   and links keep working (a right-click on a text link still offers "open in new tab"). It deters casual copying; it cannot
   stop someone reading the page source. */
(function () {
  "use strict";
  if (window.__tk9Guard) return;
  window.__tk9Guard = true;
  var ROOT = ".tkb, .tka, .tkh", OK = "input, textarea, select, [contenteditable], .tkh-answer, [data-copy-ok]";
  var el = function (n) { return n && n.nodeType === 1 ? n : n && n.parentElement; };
  var guarded = function (n) { n = el(n); return !!(n && n.closest(ROOT) && !n.closest(OK)); };
  document.addEventListener("contextmenu", function (e) {
    var n = el(e.target);
    if (!guarded(n)) return;
    var media = n.closest("img, video, picture, figure, [class*='-bit'], [class*='-cast'], [class*='-peek']");
    if (media || !n.closest("a[href], button")) e.preventDefault();
  });
  document.addEventListener("dragstart", function (e) { if (guarded(e.target)) e.preventDefault(); });
  document.addEventListener("selectstart", function (e) { if (guarded(e.target)) e.preventDefault(); });
  document.addEventListener("copy", function (e) { var s = window.getSelection && window.getSelection(); if (s && s.rangeCount && guarded(s.anchorNode)) e.preventDefault(); });
})();

/* Hero reel (2026-10-05): the Home hero moves through several products. The first photo is in the HTML; the other photos
   and every clip get their sources only after the page has loaded, so nothing competes with the first paint. Each slide
   shows its photo, plays its own short silent clip once (the photo is the clip's first frame), then the next slide cuts
   in. Tabs and a swipe jump to a slide; the pause button stops the reel. Under reduced motion, Save-Data or a 2g
   connection there are no clips and nothing moves by itself: the tabs still work. The change is a cut, never a dissolve. */
(function () {
  var box = document.querySelector('[data-tkb-slides]'); if (!box) return;
  var slides = Array.prototype.slice.call(box.querySelectorAll('.tkb-slide'));
  var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-tkb-slide-tab]'));
  var pauseBtn = document.querySelector('[data-tkb-slide-pause]');
  if (slides.length < 2 || tabs.length !== slides.length) return;
  var cur = 0, timer = 0, fed = false, paused = false;
  var conn = navigator.connection || {};
  var calm = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var lite = calm || !!conn.saveData || /2g/.test(conn.effectiveType || '');
  var small = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  function clipOf(i) { return slides[i].querySelector('video'); }
  function feed() {
    if (fed) return; fed = true;
    Array.prototype.forEach.call(box.querySelectorAll('[data-srcset]'), function (n) { n.srcset = n.getAttribute('data-srcset'); });
    Array.prototype.forEach.call(box.querySelectorAll('img[data-src]'), function (n) { n.src = n.getAttribute('data-src'); });
  }
  function ready(i) { var img = slides[i].querySelector('.tkb-slide-photo img'); return !img || (img.complete && img.naturalWidth > 0); }
  function later(ms) { window.clearTimeout(timer); if (!paused && !calm) timer = window.setTimeout(function () { show(cur + 1, false); }, ms); }
  function play(i) {
    var v = clipOf(i); window.clearTimeout(timer);
    if (lite || !v) { later(6000); return; }
    if (!v.getAttribute('src')) { v.src = v.getAttribute(small ? 'data-src-sm' : 'data-src'); v.load(); }
    try { if (v.ended || v.currentTime > 0) v.currentTime = 0; } catch (e) {}
    var p = v.play(); if (p && p.catch) p.catch(function () {});
    later(9000); /* if the clip never starts, the photo still gives way to the next slide */
  }
  slides.forEach(function (slide, i) {
    var v = clipOf(i); if (!v) return;
    v.addEventListener('playing', function () { if (i !== cur) { v.pause(); return; } v.classList.add('is-on'); window.clearTimeout(timer); });
    v.addEventListener('ended', function () { if (i === cur && !paused) show(cur + 1, false); });
    v.addEventListener('error', function () { if (i === cur) later(5000); });
  });
  function show(i, byUser) {
    feed(); i = (i + slides.length) % slides.length;
    if (!ready(i)) {
      var img = slides[i].querySelector('.tkb-slide-photo img');
      if (byUser && img) img.addEventListener('load', function () { show(i, true); }, { once: true }); else later(1500);
      return;
    }
    if (i !== cur) {
      var old = clipOf(cur); if (old) { old.pause(); old.classList.remove('is-on'); }
      box.classList.add('is-live');
      slides[cur].classList.remove('is-on'); tabs[cur].setAttribute('aria-selected', 'false');
      cur = i; slides[cur].classList.add('is-on'); tabs[cur].setAttribute('aria-selected', 'true');
    }
    if (!paused) play(cur);
  }
  tabs.forEach(function (tab, i) { tab.addEventListener('click', function () { show(i, true); }); });
  if (pauseBtn && !calm) {
    pauseBtn.hidden = false;
    pauseBtn.addEventListener('click', function () {
      paused = !paused; pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      pauseBtn.setAttribute('aria-label', paused ? 'Play the moving pictures' : 'Pause the moving pictures');
      var v = clipOf(cur);
      if (paused) { window.clearTimeout(timer); if (v) v.pause(); }
      else if (v && v.classList.contains('is-on') && !v.ended) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else play(cur);
    });
  }
  var x0 = null;
  box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  box.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 44) show(cur + (dx < 0 ? 1 : -1), true); }, { passive: true });
  document.addEventListener('visibilitychange', function () {
    var v = clipOf(cur);
    if (document.hidden) { window.clearTimeout(timer); if (v) v.pause(); }
    else if (!paused && !calm) { if (v && v.classList.contains('is-on') && !v.ended) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else play(cur); }
  });
  function start() { feed(); if (!calm) play(0); }
  if (document.readyState === 'complete') window.setTimeout(start, 1200); else window.addEventListener('load', function () { window.setTimeout(start, 1200); });
})();
